<template>

	<div class="abow_wbox bkf7">
		<div class="inter">
			<div class="flex_box_bt">
				<div class="fl">
					<ul class="ableft_menu">
						<li @click="chose(index)" :class="{'active':active == item.id}" v-for="(item, index)  in list">
							{{item.title}}
						</li>
					</ul>
				</div>
				<div class="fr">
					<h1 class="title">{{title}}</h1>
					<div class="con" v-html="content">

					</div>
				</div>
			</div>
		</div>
	</div>

</template>


<script>
	export default {
		data() {
			return {
				list: [],
				content: "",
				active: 0,
				title: "",
				index: 0,
			}
		},
		created: function(data) {
			if (this.$route.query.id != undefined) {
				this.active = this.$route.query.id
				this.index = this.$route.query.index
			}
			this.getmenu();

		},
		watch: {
			$route() {

			}
		},
		methods: {
			chose(index) {
				this.active = this.list[index].id;
				this.title = this.list[index].title
				this.content = this.list[index].content;
			},
			getmenu() {
				var that = this;
				this.rq.requests.post("api/game/cms/arclist2", {
					channel: 11,
				}).then(res => {
					that.list = res.data;
					if (that.list.length > 0) {

						if (that.active == 0) {
							that.active = that.list[0].id;
							that.content = that.list[0].content;
							that.title = that.list[0].title;
						} else {
							that.content = that.list[that.index].content;
							that.title = that.list[that.index].title;
						}

					}

				}).catch(error => {

				})
			},

		}


	}
</script>